export interface TargetClassForm {
  targetClassName?: string,
  targetClassDescription?: string,
  autoDestroy?: boolean,
  enableTeacherAutoJoin?: boolean,
  userIds?: number[],
  classroomId?: number
}

export enum TargetCloseEnum {
  CLOSE,
  FINISH
}
